var React = require('react');

function ListInline (props) {
    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Lunacy"),React.createElement("g",{"id":"Icon","key":1},React.createElement("path",{"d":"M2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4ZM14 2.1L4.9 2.1L4.9 0.7L14 0.7L14 2.1ZM2.8 7C2.8 7.7732 2.1732 8.4 1.4 8.4C0.626801 8.4 0 7.7732 0 7C0 6.2268 0.626801 5.6 1.4 5.6C2.1732 5.6 2.8 6.2268 2.8 7ZM14 7.7L4.9 7.7L4.9 6.3L14 6.3L14 7.7ZM2.8 12.6C2.8 13.3732 2.1732 14 1.4 14C0.626801 14 0 13.3732 0 12.6C0 11.8268 0.626801 11.2 1.4 11.2C2.1732 11.2 2.8 11.8268 2.8 12.6ZM14 13.3L4.9 13.3L4.9 11.9L14 11.9L14 13.3Z","id":"Combined-Shape","fill":"#1D355B","fillRule":"evenodd","stroke":"none"}))]);
}

ListInline.defaultProps = {"width":"14px","height":"14px","viewBox":"0 0 14 14","version":"1.1"};

module.exports = ListInline;

ListInline.default = ListInline;
